module.exports = __webpack_public_path__ + "img/ch08_05_窗边蛋糕.3a3307a6.jpg";